<template>
  <content-editor
    permission="blog"
    :fields="fields"
    @update="updateState"
    :publication="true"
    :updatePossible="true"
    endpoint="blog"
    previewModule="blog"
    module="blog"
    />
</template>

<script>
import ContentEditor from '@/components/editor/content_blocks/ContentEditor.vue';
import ContentDetail from '@/mixins/contentEditor/Detail';

export default {
  mixins: [ContentDetail],
  data() {
    return {
      module: 'blog',
      fields: [
        {
          name: 'notes',
          required: false,
        },
        {
          name: 'title',
          required: true,
        },
        {
          name: 'url',
          required: true,
        },
        {
          name: 'status',
          required: true,
        },
        {
          name: 'recap',
          required: true,
        },
        {
          name: 'categories',
          required: true,
        },
        {
          name: 'tags',
          required: false,
        },
        {
          name: 'image',
          required: true,
        },
      ],
    };
  },
  components: {
    ContentEditor,
  },
};
</script>
